module.exports = __webpack_public_path__ + "static/indexFooter.15a4ad70f8e409eee993c81a40e4c1d3.png";